import { FlowV2_Action__Input } from '~/graphql/types';
import { ClientFlowActionContactAssign } from '~/graphql/types.client';
import removeTypenames from '../../../removeTypenames';

/**
 *
 * @param {ClientFlowActionContactAssign} action - ContactAssign client action
 * keywords:
 */
const serializeContactAssignAction = (
  action: ClientFlowActionContactAssign,
): FlowV2_Action__Input => {
  const {
    id,
    accountId,
    flowBlueprintId,
    parentIds,
    overwriteAssignee,
    office,
    user,
  } = action;

  return {
    Contact: {
      Assign: removeTypenames({
        id,
        accountId,
        flowBlueprintId,
        parentIds,
        office,
        user,
        overwriteAssignee,
      }),
    },
  };
};
export default serializeContactAssignAction;
